<template>
  <div
    :class="[
      'protocol-container',
      isMobile ? 'mobile' : ''
    ]"
  >
    <div class="protocol">
      <p class="title">第三方SDK收集个人信息列表</p>
      <div class="container">
        <p>
          为确保部分独立功能的实现，我们的部分服务及功能由第三方SDK提供。我们将审慎评估该等SDK的使用目的。
        </p>
        <p>
          请您理解，第三方SDK的功能和服务是不断更新和发展的，其处理的数据类型等内容可能会因为功能或策略调整存在一定的变化，请以第三方公示的有关个人信息的介绍为准。
        </p>
        <table class="table">
          <tr class="tb-title">
            <th>SDK名称</th>
            <th>第三方名称</th>
            <th>使用目的</th>
            <th>数据类型</th>
            <th>开放平台/隐私政策链接</th>
          </tr>
          <tr>
            <td>微信分享SDK</td>
            <td>腾讯公司</td>
            <td>用户可使用微信登陆应用并帮助用户将特定内容分享到微信</td>
            <td>设备标识信息、网络状态</td>
            <td>
              <a href="https://privacy.qq.com/policy/tencent-privacypolicy"
                >https://privacy.qq.com/policy/tencent-privacypolicy</a
              >
            </td>
          </tr>
          <tr>
            <td>腾讯Bugly</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>运营统计和收集并上报应用异常信息</td>
            <td>设备标识信息、网络状态、低级别系统日志文件</td>
            <td>
              <a
                href="https://privacy.qq.com/document/priview/fbd2c3f898df4c1c869925dd49d57827"
                >https://privacy.qq.com/document/priview/fbd2c3f898df4c1c869925dd49d57827</a
              >
            </td>
          </tr>
          <tr>
            <td>高德地图SDK</td>
            <td>高德软件有限公司</td>
            <td>为用户提供2D、3D地图，提供地图搜索、定位能力</td>
            <td>设备标识信息、网络状态、地理位置信息</td>
            <td>
              <a href="https://lbs.amap.com/pages/privacy/"
                >https://lbs.amap.com/pages/privacy/</a
              >
            </td>
          </tr>
          <tr>
            <td>微信支付SDK</td>
            <td>财付通支付科技有限公司</td>
            <td>为用户提供应用内微信支付功能</td>
            <td>设备标识信息、网络状态</td>
            <td>
              <a
                href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F"
                >https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F</a
              >
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false
    }
  },
  methods: {
    checkIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      this.isMobile = flag
    }
  },
  mounted() {
    document.title = '跟飞哥学AI'
    this.isMobile = this.checkIsMobile()
  }
}
</script>

<style lang="less" scoped>
.protocol-container {
  font-size: 16px;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;
  color: #1f2329 !important;
  .highlight {
    font-weight: 800;
  }
  html{
    font-size: 16px !important;
    overflow: auto;
  }
  .protocol {
    min-width: 470px;
    max-width: 790px;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 20px 40px;
    margin: 40px auto 0;
    background: #fff;
    box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);
    .title {
      margin: 36px 0 22px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      color: #1f2329;
      padding: 40px;
    }
    .container {
      margin-top: 20px;
      p {
        margin-bottom: 20px;
        text-indent: 2em;
      }
      .table {
        width: 100%;
        max-width: 1000px;
        margin: auto;
      }

      .table th:nth-of-type(1) {
        width: 10%;
      }
      .table th:nth-of-type(2) {
        width: 12%;
      }
      .table th:nth-of-type(3) {
        width: 28%;
      }
      .table th:nth-of-type(4) {
        width: 20%;
      }
      .table th:nth-of-type(5) {
        width: 30%;
      }
      .table,
      .table td,
      .table th {
        border: solid 2px #ddd;
        border-collapse: collapse;
        font-size: 16px;
      }

      .table th {
        // background-color: #eee;
        height: 40px;
      }
      .table td {
        padding: 5px;
      }
      a {
        word-wrap: break-word;
        word-break: break-all;
      }
      a,
      a:hover {
        // color: #333;
        text-decoration: underline;
      }
      .third-content {
        max-width: 1000px;
        margin: 10px auto;
      }
      .third-content p {
        font-size: 14px;
      }
      .p-strong {
        font-weight: bold;
        // margin-top: 40px;
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .protocol {
    width: 80%;
  }
}
// @media screen  and (max-width: 1400px){
//   .protocol{
//     width:80%
//   }
// }
@media screen and (max-width: 1279px) {
  .protocol {
    width: 70%;
  }
}
@media screen and (max-width: 900px) {
  .protocol {
    width: calc(100% - 40px);
  }
}
.mobile {
  .protocol {
    min-width: auto;
    max-width: none;
    width: 100%;
    border-radius: 4rpx;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 40rpx;
    margin: 40rpx auto 0;
    padding: 0 20rpx;
    background: #fff;
    box-shadow: 0px 0rpx 11px 0rpx rgba(63, 95, 150, 0.04);
    .title {
      margin: 36rpx 0 22rpx;
      text-align: center;
      font-size: 34rpx;
      font-weight: 500;
      color: #1f2329;
      padding: 40rpx;
    }
    .container {
      margin-top: 20rpx;
      p {
        margin-bottom: 20rpx;
        text-indent: 2em;
      }
      .table {
        width: 100%;
        // max-width: 1000px;
        margin: auto;
      }

      .table th:nth-of-type(1) {
        width: 10%;
      }
      .table th:nth-of-type(2) {
        width: 12%;
      }
      .table th:nth-of-type(3) {
        width: 28%;
      }
      .table th:nth-of-type(4) {
        width: 20%;
      }
      .table th:nth-of-type(5) {
        width: 30%;
      }
      .table,
      .table td,
      .table th {
        border: solid 1rpx #ddd;
        border-collapse: collapse;
        font-size: 16rpx;
      }

      .table th {
        // background-color: #eee;
        height: 40rpx;
      }
      .table td {
        padding: 5rpx;
      }
      a {
        word-wrap: break-word;
        word-break: break-all;
      }
      a,
      a:hover {
        // color: #333;
        text-decoration: underline;
      }
      .third-content {
        // max-width: 1000px;
        margin: 10rpx auto;
      }
      .third-content p {
        font-size: 14rpx;
      }
      .p-strong {
        font-weight: bold;
        // margin-top: 40px;
      }
    }
  }
}
// .mobile {
//   &.minip {
//     .protocol {
//       min-width: auto;
//       max-width: none;
//       width: 100%;
//       border-radius: 4px;
//       height: 100%;
//       box-sizing: border-box;
//       padding-bottom: 40px;
//       margin: 40px auto 0;
//       background: #fff;
//       box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);
//       .title {
//         font-size: 3.4rem;
//       }
//       .container {
//         font-size: 20px;
//         p {
//           margin-bottom: 20px;
//           text-indent: 2em;
//           font-size: 1.9rem;
//         }
//         .table,
//         .table th,
//         .table td {
//           font-size: 1.6rem;
//         }
//         .title {
//           font-size: 2rem;
//         }
//       }
//     }
//   }
// }
</style>
